<div class="table-header">
  <div class="header-title">
    @if (showBackArrow) {
      <g99-icon-btn
        [icon]="backArrow"
        [height]="20"
        [width]="20"
        (iconClick)="onBackButtonClick()"
      />
    }
    <h2>{{ title }}</h2>
    <span *ngIf="notificationBadgeCount" class="notification-badge">{{
      notificationBadgeCount
    }}</span>
  </div>
  <div *ngIf="!isHeaderButtonHidden" class="add-import-btn">
    <g99-button
      *ngIf="isAddTagButtonVisible"
      variant="medium"
      color="transparent-with-border"
      height="40px"
      iconColor="#000"
      [showIconOnMobile]="true"
      [svgIcon]="svgIcon"
      (buttonClick)="addTagButtonClick.emit()"
    >
      Add Tag
    </g99-button>

    <g99-button
      *ngIf="isExportButtonVisible"
      variant="medium"
      color="transparent-with-border"
      iconColor="#000"
      iconFontSize="9px"
      height="40px"
      [showIconOnMobile]="true"
      [svgIcon]="exportIcon"
      (buttonClick)="onExportClick()"
    >
      Export
    </g99-button>

    <g99-button
      *ngIf="isImportButtonVisible"
      variant="medium"
      color="transparent-with-border"
      iconColor="#000"
      iconFontSize="9px"
      height="40px"
      [showIconOnMobile]="true"
      [svgIcon]="importIcon"
      (buttonClick)="onImportClick()"
    >
      Import
    </g99-button>

    <lib-g99-shared-table-column-preference
      *ngIf="availableColumns.length > 0"
      [availableColumns]="availableColumns"
      (savePreference)="onColumnPreferenceChanged($event)"
    />

    <!-- ---------------------------- Secondary Btn ---------------------------- -->
    <g99-button
      *ngIf="secondaryButtonLabel"
      variant="medium"
      color="secondary"
      [showIconOnMobile]="true"
      [disabled]="isButtonDisable"
      (buttonClick)="secondaryButtonClick.emit()"
    >
      <g99-icon-btn [icon]="secondaryBtnIcon" />
      {{ secondaryButtonLabel }}
    </g99-button>

    <!-- ------------------------------- Add Btn ------------------------------- -->
    @if (buttonLabel) {
      <g99-button
        width="120"
        variant="medium"
        color="green"
        [svgIcon]="svgIcon"
        [showIconOnMobile]="true"
        [disabled]="isButtonDisable"
        (buttonClick)="onButtonClick()"
      >
        {{ buttonLabel }}
      </g99-button>
    }

    <!-- ------------------------------ Back Btn ------------------------------- -->
    <g99-button
      *ngIf="isBackButtonVisible"
      variant="medium"
      color="transparent-with-border"
      (buttonClick)="onBackButtonClick()"
    >
      Back
    </g99-button>
  </div>
</div>
